import styled, { css, keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

const Row = styled.div.withConfig({
  shouldForwardProp: (prop) =>
    ![
      'start',
      'between',
      'evenly',
      'alignStart',
      'alignCenter',
      'center',
      'end',
      'centerAll',
      'grid',
      'numCols',
      'rowWrap',
      'marg',
      'gap',
      'pad',
      'hasRadius',
      'bg',
      'bg2',
      'border',
      'maxWid',
      'minWid',
      'minHt',
      'ht',
      'wid',
      'pos',
      'borderBox',
      'scrollY',
      'scrollX',
      'zIndex',
      'hasBorder',
      'borderBottom',
      'borderTop',
      'justifyContent',
      'alignItems',
      'pointer',
      'top',
      'left',
      'right',
      'bottom',
      'shadow',
      'hasFlex',
      'noFlex',
      'reverse',
      'column',
      'hasFade',
      'individualRadius',
      'hideScrollBar',
      'responsive',
      'tabletHt',
      'tabletPos',
      'enableMediaQuery',
      'mobileToTablet',
      'isColumn',
      'overflow',
      'display',
      'wrapFlex'
    ].includes(prop)
})`
  display: ${(props) => (props.display ? props.display : 'flex')};
  flex-direction: row;
  margin: ${(props) => props.marg && props.marg};
  gap: ${(props) => props.gap && props.gap};
  padding: ${(props) => props.pad && props.pad};
  justify-content: ${(props) =>
    props.between
      ? 'space-between'
      : props.evenly
        ? 'space-evenly'
        : props.start
          ? 'flex-start'
          : 'inherit'};
  ${(props) => props.grid && 'display: grid'};
  ${(props) => props.alignStart && 'align-self: flex-start'};
  ${(props) => props.alignCenter && 'align-self: center'};
  border-radius: ${(props) => props.hasRadius && props.hasRadius};
  background-color: ${(props) => props.bg && props.bg};
  background: ${(props) => props.bg2 && props.bg2};
  align-items: ${(props) => (props.center ? 'center' : props.end ? 'flex-end' : 'flex-start')};
  border: ${(props) => props.border && '0.1px solid #ddd'};
  max-width: ${(props) => props.maxWid && props.maxWid};
  min-width: ${(props) => props.minWid && props.minWid};
  min-height: ${(props) => props.minHt && props.minHt};
  flex-wrap: ${(props) => (props.wrapFlex ? 'wrap' : 'inherit')};
  height: ${(props) => props.ht || 'auto'};
  width: ${(props) => props.wid || 'auto'};
  position: ${(props) => props.pos || 'unset'};
  ${(props) => props.borderBox && 'box-sizing: border-box'};

  ${(props) =>
    props.grid &&
    css`
      grid-template-columns: repeat(${props.numCols || 1}, 1fr);
    `}
  ${(props) => props.rowWrap && `flex-direction: row; flex-wrap: wrap;`};

  ${(props) => props.scrollY && `overflow-y: scroll;`};
  ${(props) => props.scrollX && `overflow-x: scroll;`};
  ${(props) => props.zIndex && `z-index: ${props.zIndex};`};

  ${(props) => props.hasBorder && `border: ${props.hasBorder};`}
  ${(props) => props.borderBottom && `border-bottom: ${props.borderBottom};`}
  ${(props) => props.borderTop && `border-top: ${props.borderTop}`}
  ${(props) => props.justifyContent && `justify-content: ${props.justifyContent}`}
  ${(props) => props.alignItems && `align-items: ${props.alignItems}`}

  ${(props) =>
    props.centerAll &&
    `
    align-items: center;
    justify-content: center;
  `};

  ${(props) =>
    props.pointer &&
    css`
      cursor: pointer;

      p {
        cursor: pointer;
      }
    `};

  ${(props) => props.top && `top: ${props.top};`};
  ${(props) => props.left && `left: ${props.left};`};
  ${(props) => props.right && `right: ${props.right};`};
  ${(props) => props.bottom && `bottom: ${props.bottom};`};

  ${(props) => props.shadow && `box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.2);`}

  ${(props) =>
    props.hasFlex &&
    css`
      flex: 1;
    `};

  ${(props) =>
    props.reverse &&
    css`
      flex-direction: row-reverse;
    `};
  ${(props) =>
    props.column &&
    css`
      flex-direction: column;
    `};

  ${(props) =>
    props.hasFade &&
    css`
      animation: ${fadeIn} 0.3s linear;
    `}

  ${(props) =>
    props.individualRadius &&
    `
    border-top-left-radius: ${props.individualRadius[0]};
    border-top-right-radius: ${props.individualRadius[1]};
    border-bottom-right-radius: ${props.individualRadius[2]};
    border-bottom-left-radius: ${props.individualRadius[3]};
  `}

  ${(props) =>
    props.hideScrollBar &&
    `
    &::-webkit-scrollbar {
      display: none;
    }

    -ms-overflow-style: none;
    scrollbar-width: none;
  `}

  ${(props) =>
    props.scrollX &&
    `
    overflow-x: scroll;
  `}

  ${(props) =>
    props.responsive &&
    css`
      @media (min-width: 768px) {
        width: 40%;
        flex-direction: row;
      }

      @media (min-width: 1024px) {
        width: 100%;
      }
    `}

  ${(props) =>
    props.overflow &&
    css`
      overflow: ${props.overflow};
    `};

  ${(props) =>
    props.enableMediaQuery &&
    css`
      @media (min-width: 426px) and (max-width: 1024px) {
        ${props.tabletHt ? `height: ${props.tabletHt} !important;` : ''}
        ${props.tabletPos ? `position: ${props.tabletPos} !important;` : ''}
      }
    `}

  ${(props) =>
    props.mobileToTablet &&
    css`
      @media (max-width: 1024px) {
        ${props.isColumn ? `flex-direction: column !important` : ''}
      }
    `}
`;

export default Row;
